const styles = theme => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '40px',
    padding: '64px 64px',
  },

  creationCards: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    //gap: '20px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 500,
    textAlign: 'center',
  },
})

export default styles
